import { Col, Row } from "antd";
import { BsCameraFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { UPLOADS_URL } from "../../config/constants/api";

const Profile = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state?.user?.userData);

  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 py-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <h3 className="font-tavi text-3xl font-normal text-black ml-8 mb-4">
            My Profile
          </h3>
          <Row justify="center">
            <Col xs={22} sm={18} md={18} xl={12}>
              <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-center justify-center sm:py-12 py-6">
                <img src={UPLOADS_URL+userData?.image} style={{height:"100px" , width : '100px' , objectFit:'cover' , objectPosition:'center' , borderRadius:"100%" }} alt="profile" />
                <div className="flex justify-center items-center p-2 bg-customGold rounded-full mt-[-20px] ml-[50px]">
                  <BsCameraFill size={16} className="text-white" />
                </div>

                <div className="flex justify-center items-center my-4">
                  <div className="flex flex-col items-start sm:mr-16 mr-8">
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      First Name
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {userData?.firstName}
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Contact Number
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {userData?.phone}
                    </p>
                  </div>
                  <div className="flex flex-col items-start">
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Last Name
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {userData?.lastName}
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Email Address
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {userData?.email}
                    </p>
                  </div>
                </div>
                <button
                  className="uppercase bg-button py-4 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4"
                  onClick={() => navigate("/updateProfile")}
                >
                  UPDATE PROFILE
                </button>
                <Link to="/changePassword" className="font-euclid uppercase text-sm border-b border-black text-black hover:text-black my-6 font-bold">change Password</Link>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default Profile;
